import React from 'react'

import { Link } from 'gatsby'
import styled from 'styled-components'

import Layout from '../components/core/layout'
import SEO from '../components/core/seo'
import ProgramSelector from '../components/cross-template-statics/ProgramSelector'
import UtilityHeader from '../components/headers/UtilityHeader'
import SearchBar from '../components/navigation/SearchBar'
import { colors } from '../style/design-system'

const FourOhFour = ({ className }) => (
  <Layout>
    <SEO title="Page Not Found" noUmaInTitle />
    <UtilityHeader>
      <h1>404 Page Not Found</h1>
    </UtilityHeader>
    <div className={`${className} py-9`}>
      <div className="container">
        <h2 className="h3">Search ultimatemedical.edu:</h2>

        <div className="row">
          <div className="col-12 col-md-8 col-lg-6">
            <SearchBar />
          </div>
        </div>

        <h2 className="h3 mt-10 mb-8">
          Explore our associate degree and
          <span className="nowrap">diploma programs:</span>
        </h2>
      </div>

      <ProgramSelector />

      <div className="container">
        <p className="mt-10 h4">
          Still lost? Let's go back
          <Link to="/">home</Link>.
        </p>
      </div>
    </div>
  </Layout>
)

export default styled(FourOhFour)`
  [class^='SearchBar'] input {
    background-color: ${colors.umaLightGray};
    margin: auto;
  }
`
